import { InfoToken } from "../interfaces/http.interface";

const isTokenExpired = (creationTime: number, expirationTime: number) => ((Date.now() - creationTime) > (expirationTime * 1000));

export const getInfoToken = async (): Promise<InfoToken> => {
  
  const infoTokenStorage = sessionStorage.getItem("infoToken");
  let infoToken = infoTokenStorage? (JSON.parse(infoTokenStorage) as InfoToken) : {
      created: 0,
      expires: 0,
      token: ""
    };
   
  if(!infoToken.token || isTokenExpired(infoToken.created, infoToken.expires)){
    
      const endpointAuth = import.meta.env.VITE_AUTH_URL;
      const baseUrlToken = import.meta.env.VITE_API_URL_BASE_AUTH;

      const responseToken =  await fetch(`${baseUrlToken}${endpointAuth}`, {method: 'POST', body: JSON.stringify({resource: import.meta.env.VITE_RESOURCE_TOKEN})});
      if(responseToken.ok){
        const dataToken = await responseToken.json();
        const { access_token, expires_in } = dataToken ?? {};
        infoToken = {
            created: Date.now(),
            expires: Number(expires_in) - 20,
            token: access_token
      };
      sessionStorage.setItem("infoToken", JSON.stringify(infoToken));
      }
      
      
  }
  

  return infoToken;
}